module.exports = __webpack_public_path__ + "img/Arminia-Bielefeld.f75a3152.png";